import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import * as React from 'react';
export var ModalManager = function () {
  function ModalManager() {
    _classCallCheck(this, ModalManager);
    this.modals = new Map();
  }
  _createClass(ModalManager, [{
    key: "triggerModal",
    value: function triggerModal(key) {
      var modalItem = this.modals.get(key);
      if (!modalItem) {
        throw new Error('Modal does not exist!');
      }
      if (modalItem.ref.current) {
        modalItem.ref.current.open();
      }
    }
  }, {
    key: "getModals",
    value: function getModals() {
      return this.modals;
    }
  }, {
    key: "registerModal",
    value: function registerModal(key, ModalComponent, modalProps) {
      var modalRef = React.createRef();
      var modalComponent = React.createElement(ModalComponent, _objectSpread(_objectSpread({}, modalProps), {}, {
        ref: modalRef
      }));
      var modal = {
        ref: modalRef,
        element: modalComponent
      };
      this.modals.set(key, modal);
    }
  }, {
    key: "renderModals",
    value: function renderModals() {
      var modalComponents = [];
      this.modals.forEach(modal => {
        modalComponents.push(modal.element);
      });
      return modalComponents;
    }
  }, {
    key: "removeAllModals",
    value: function removeAllModals() {
      this.modals = new Map();
    }
  }]);
  return ModalManager;
}();